import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import get from "lodash/get";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import getImageUrl from "@configuratorware/configurator-frontendgui/App/Utils/getImageUrl";
import customClassName from "@configuratorware/configurator-frontendgui/App/Utils/customClassName";
import { Hyphenated } from "@configuratorware/configurator-frontendgui/Framework/i18n";

const useStyles = makeStyles(
  (theme) => {
    const captionMaxHeight = `calc(${theme.creator.productPart.captionPaddingTop} + ${theme.creator.productPart.lineHeight} * 2)`;
    const iconMaxHeigth = `calc(${theme.creator.productPart.itemSize} - ${captionMaxHeight}  - ${theme.creator.productPart.captionPaddingTop})`;

    return {
      root: {
        [theme.breakpoints.up("sm")]: {
          width: theme.creator.productPart.selectedItemSize,
        },
        width: theme.creator.productPart.itemSize,
        height: 32, // arrow height

        "&.horizontal": {
          padding: "0 10px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "end",
        },
      },
      content: {
        padding: "0px 25px",
        paddingBottom: 5,
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        textAlign: "center",
        position: "relative",
        "&.selected .MuiTypography-root": {
          fontWeight: "bold",
        },
        "&.hover .MuiTypography-root": {
          fontWeight: "bold",
          color: theme.palette.productList.hoverText,
        },
        "&.horizontal": {
          width: theme.creator.productPart.itemSize,
          minWidth: theme.creator.productPart.minItemSize,
          height: "auto",
          float: MARKER_POSITION.top,
          marginTop: "auto",
          whiteSpace: "normal",
          "& span": {
            marginBottom: 0,
            whiteSpace: "nowrap",
          },
        },
      },
      icon: {
        maxHeight: iconMaxHeigth,
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        backgroundSize: "contain",
        display: "block",
        "&.horizontal": {
          width: theme.creator.productPart.itemSize,
          height: `calc(0.75*${theme.creator.productPart.itemSize})`,
        },
      },
      marker: {
        backgroundColor: "transparent",
        "&.horizontal": {
          width: theme.creator.productPart.itemSize,
          minWidth: theme.creator.productPart.minItemSize,
          height: theme.creator.productPart.markerThickness,
        },
        "&.selected": {
          backgroundColor: theme.palette.primary.main,
        },
        "&.hover": {
          backgroundColor: theme.palette.productList.hover,
        },
      },
      rootTypography: {
        padding: "3px 0 0 7px",
        marginBottom: 5,
        display: "-webkit-box",
        overflow: "hidden",
        wordWrap: "break-word",
        maxWidth: theme.creator.productPart.itemSize,
        lineHeight: 1,
        boxOrient: "vertical",
        lineClamp: 3,
        minHeight: 20,
      },
      rootTypographyRemovePadding: {
        padding: "0 0 0 7px",
      },
    };
  },
  { name: "ProductPart" }
);

const CustomProductPart = ({
  onSelect,
  optionclassification,
  selectedOption,
  setAnchorRef,
  showMarker,
}) => {
  // console.log('!!!!selected', selectedOption, optionclassification, get(selectedOption, 'identifier', null), get(optionclassification, 'identifier', ''));
  const selected =
    get(selectedOption, "identifier", null) ===
    get(optionclassification, "identifier", "");
  const direction = "horizontal";
  const classes = useStyles();

  const [hover, setHover] = useState(false);

  const displayText = () => (
    <Typography variant="h3" component="span">
      <Hyphenated>{optionclassification.title}</Hyphenated>
    </Typography>
  );

  const onClick = (event) => {
    event.stopPropagation();
    onSelect(optionclassification, event.currentTarget);
  };
  const onHover = (value) => {
    setHover(value);
  };
  return (
    <div
      onMouseEnter={() => onHover(true)}
      onMouseLeave={() => onHover(false)}
      className={clsx(classes.root, direction, customClassName("component"))}
      ref={setAnchorRef}
    >
      <div
        className={`${classes.content} ${direction}  ${
          selected && showMarker ? "selected" : ""
        }  ${hover ? "hover" : ""}`}
        onClick={onClick}
      >
        {displayText()}
      </div>
      <div
        className={`${classes.marker} ${direction} ${
          selected && showMarker ? "selected" : ""
        } ${hover ? "hover" : ""}`}
      />
    </div>
  );
};

const MARKER_POSITION = {
  left: "left",
  right: "right",
  top: "top",
};

CustomProductPart.defaultProps = {
  optionclassification: {},
  onSelect: () => {},
  verticalMode: true,
  showMarker: false,
};

CustomProductPart.propTypes = {
  displaySwitchedOptions: PropTypes.bool,
  onSelect: PropTypes.func,
  optionclassification: PropTypes.object,
  selectedOption: PropTypes.object,
  verticalMode: PropTypes.bool,
  setAnchorRef: PropTypes.func,
  showMarker: PropTypes.bool,
};

export default CustomProductPart;
